import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import { setLocation } from "../redux/slices/locationSlice";
import { setGlobalConfig } from "../redux/slices/globalconfigurations.slice";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 450,
  width: "95%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  paddingTop: 2,
  paddingBottom: 2,
  paddingLeft: 3,
  paddingRight: 3,
  borderRadius: "10px",
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "35ch",
      borderRadius: "15%",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  paper: {
    position: "absolute",
    width: 300,
    backgroundColor: "#fff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
    padding: 20,
    outline: "none",
    borderRadius: "2%",
    overflow: "hidden",
  },
  button: {
    textTransform: "lowercase",
  },
  heading: {
    fontFamily: "Goudy Bookletter 1911, sans-serif",
    fontSize: "16px",
    marginBottom: "10px",
  },
  label: {
    fontWeight: "bold",
  },
  formContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    marginTop: "5%",
  },
  fieldContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%"
  },
}));

export default function MyGlobalConfigForm({ selectedOption }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const headers = useSelector((state) => state.header);
  const classes = useStyles();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [success, setSuccessMessage] = useState();
  const api = localStorage.getItem("api");
  const curremms = useSelector((state) => state.curremms);
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    key: "",
    value: "",
    customProperties: {},
  });

  const emmsheaders = useSelector((state) => state.emmsheader);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!formData.name && !formData.value) {
      toast.error("Please fill all the required fields", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }
    setIsSubmitting(true);

    const valuesArray = formData?.value.split(",").map((val) => val.trim());
    const json2 = {
      key: formData?.key,
      values: valuesArray,
    };

    const requestBody = {
      path: "globalconfigurations",
      query: {},
      emmsId: `${selectedOption}`,
      body: { ...json2 },
      requestType: "POST",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then((response) => {
        setIsSubmitting(false);
        dispatch(setGlobalConfig(response?.data));
        setErrorModalOpen(true);
        setErrorMessage(`Configurations Added Successfully`);
        setFormData({
          key: "",
          value: "",
          customProperties: {},
        });
        setSuccessMessage(true);
      })
      .catch((error) => {
        setErrorModalOpen(true);
        setErrorMessage(`Error adding config: ${error?.response?.data}`);
        setFormData({
          key: "",
          value: "",
          customProperties: {},
        });
        setSuccessMessage(false);
      });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleModalClose = () => {
    setErrorModalOpen(false);
    setErrorMessage("");
    setOpen(false);
    setIsSubmitting(false);
  };
  const getLabelWithAsterisk = (labelText, isRequired) => {
    return (
      <div style={{ display: "flex", alignItems: "center", width: "200px" }}>
        <label className={classes.label} htmlFor={labelText}>
          {labelText}
        </label>
        {isRequired && <span style={{ color: "red" }}>*</span>}
      </div>
    );
  };

  return (
    <div>
      <Button
        style={{ textTransform: "none" }}
        variant="contained"
        color="primary"
        onClick={handleOpen}
      >
        Add Config
      </Button>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <form
            className={classes.root}
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <div>
              <h2>Configurations</h2>
              <h4 style={{ fontWeight: "100" }}>
                Add configurations for {curremms?.curremms?.name}
              </h4>
            </div>

            <div
              className={classes.formContainer}
              style={{ display: "flex", gap: "16px" }}
            >
              {getLabelWithAsterisk("Configuration Key-Value:", true)}
              <div className={classes.fieldContainer}>
                <TextField
                  style={{ width: "100px" }}
                  required
                  id="key"
                  label="Key"
                  name="key"
                  margin="none"
                  size="small"
                  variant="outlined"
                  value={formData.key}
                  onChange={handleChange}
                />
                <TextField
                  required
                  id="value"
                  label="Value"
                  name="value"
                  margin="none"
                  size="small"
                  multiline
                  rows={3}
                  variant="outlined"
                  value={formData.value}
                  onChange={handleChange}
                />
              </div>
            </div>


            <Box
              sx={{
                display: "flex",
                gap: 2,
                mt:2,
                justifyContent:"end"
              }}
            >
              <Button
                style={{ textTransform: "none" }}
                variant="outlined"
                color="error"
                onClick={() => setOpen(false)}
                disabled={isSubmitting}
              >
                Close
              </Button>

              <Button
                style={{
                  textTransform: "none",
                }}
                type="submit"
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting ? <CircularProgress size={24} /> : "Submit"}
              </Button>

            </Box>

            <Modal
              open={errorModalOpen}
              onClose={handleModalClose}
              className={classes.modal}
            >
              <div className={classes.paper}>
                {success ? <h2>Congratulations</h2> : <h2>Error</h2>}
                <p>{errorMessage}</p>
                <Button
                  style={{
                    textTransform: "none",
                    marginLeft: "75%",
                  }}
                  onClick={handleModalClose}
                  variant="contained"
                  color="primary"
                >
                  Close
                </Button>
              </div>
            </Modal>
          </form>
        </Box>
      </Modal>
    </div>
  );
}
